var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionVehicleIntegrationColored({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M2 11H22C22.5523 11 23 11.4477 23 12V17C23 18.6569 21.6569 20 20 20H2V11Z",
    fill: "#5714CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7C6 6.44772 6.44772 6 7 6H21C21.5523 6 22 6.44772 22 7V17C22 17.5523 21.5523 18 21 18H7C6.44772 18 6 17.5523 6 17V7Z",
    fill: "#5714CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8H20V16H8V8Z",
    fill: "#FFC107"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8H17L19 16H14L16 8Z",
    fill: "#C5ACED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.07324C4.39049 4.45666 6 7.0394 6 10C6 12.9606 4.39049 15.5433 2 16.9268V14.4678C2.99058 13.5807 3.68514 12.3699 3.91504 11H2V9H3.91504C3.68508 7.62977 2.99094 6.4172 2 5.5293V3.07324Z",
    fill: "#2D3C53"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.2C9 9.08954 9.08954 9 9.2 9H12.8C12.9105 9 13 9.08954 13 9.2V12.8C13 12.9105 12.9105 13 12.8 13H9.2C9.08954 13 9 12.9105 9 12.8V9.2Z",
    fill: "#2D3C53"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3799 13.1895L16.7422 13.0303L16.5 12.9688L16.2578 13.0303L15.6191 13.1895L16.499 11.6582L17.3799 13.1895Z",
    stroke: "#5714CC",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionVehicleIntegrationColored);
export default __webpack_public_path__ + "static/media/ic_action_vehicle_integration_colored.8488e97898c8b607bbc9e308ab4317e4.svg";
export { ForwardRef as ReactComponent };